/**
 * Custom-passage utilities for the LEARN drills.
 *
 * When the user runs "Bring your own passage", the modal saves the
 * generated passage (`{passage_id, text, questions, vocab, ...}`) to
 * sessionStorage under `learn_custom_passage`. Every drill page then
 * uses this helper on mount to decide whether to serve the user's
 * own text or fall back to the bundled bank.
 *
 * sessionStorage is per-tab so multi-tab reads never collide, and the
 * key is cleared automatically when the tab closes.
 */
export const CUSTOM_PASSAGE_KEY = 'learn_custom_passage';

export const readCustomPassage = () => {
  try {
    const raw = sessionStorage.getItem(CUSTOM_PASSAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearCustomPassage = () => {
  try { sessionStorage.removeItem(CUSTOM_PASSAGE_KEY); } catch { /* no-op */ }
};
